export default "__VITE_ASSET__DQCkRgUi__"